import { XIcon } from 'lucide-react';
import { useEffect } from 'react';

interface FullscreenModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
}

export default function FullscreenModal({ isOpen, onClose, title, children }: FullscreenModalProps) {
    // Disable body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-white dark:bg-gray-900 animate-in fade-in-0 zoom-in-95">
            <div className="relative h-full w-full overflow-y-auto">
                {/* Header */}
                <div className="sticky top-0 z-50 flex items-center justify-between border-b bg-white dark:bg-gray-900 px-4 py-4 sm:px-6">
                    <h2 className="text-lg font-semibold text-black dark:text-white">{title}</h2>
                    <button
                        onClick={onClose}
                        className="rounded-full p-2 hover:bg-gray-100 dark:hover:bg-gray-800"
                    >
                        <XIcon className="h-5 w-5 text-black dark:text-white" />
                        <span className="sr-only">Close</span>
                    </button>
                </div>

                {/* Content */}
                <div className="px-4 py-6 sm:px-6">
                    {children}
                </div>
            </div>
        </div>
    );
}
